
    import * as React from 'react';

    const Account16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M4.378 13.077A6.208 6.208 0 008 14.237a6.21 6.21 0 003.628-1.163c-.02-1.692-1.611-3.699-3.647-3.699-2.032 0-3.587 1.995-3.603 3.702zm-.7-.581c.31-1.92 2.039-3.871 4.303-3.871s4.024 1.958 4.344 3.868a6.237 6.237 0 10-8.648.003zM8 15A7 7 0 118 1a7 7 0 010 14zm0-7a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0-.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z" /></svg>
        </div>
      );
    };

    Account16.displayName = 'Account16';

    export default Account16;
  